import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import messages from '../../../../../text/messages';
import { formSettings } from './settings';
import WizardButtons from '../../../../../components/wizard/navigator/buttons';
import { logout } from '../../../../../reducers/identity';
import { FormattedMessage } from 'react-intl';

class RejectedStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    submit() {
        const { logout } = this.props;
        logout(() => (window.location = 'http://www.greenlight.ai'));
    }

    render() {
        const { handleSubmit, submitting, back, details } = this.props;
        const { worker_first_name, worker_last_name } = details;
        const worker_name = worker_first_name + ' ' + worker_last_name;

        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'rejected.witness.intro'}
                            defaultMessage={
                                "OK, we'll notify {name} of the problem and ask for the document submission to be corrected.  Thank you for your time."
                            }
                            values={{ name: worker_name }}
                        />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.ok} /> }} />
            </form>
        );
    }
}

RejectedStep = reduxForm(formSettings)(RejectedStep);
const mapStateToProps = state => {
    return {
        role: state.identity.role,
        details: state.identity.details
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            logout
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RejectedStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/rejected.jsx